import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { Acumulador } from '../models/acumulador';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/Acumuladores';

@Injectable({
  providedIn: 'root'
})
export class AcumuladorService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  save(acumulador: Acumulador)
  {
    return this._http.post({ url: baseUrl + '/Save', body: acumulador });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }

  getList(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/List' })
  }

}

